// extracted by mini-css-extract-plugin
export default {"line":"statusCommissions_line__wFB23","lineFirst":"statusCommissions_lineFirst__UW92-","title":"statusCommissions_title__ECvd8","dot":"statusCommissions_dot__5MZKO"};